export type MenuItems = {
  label: string;
  icon: JSX.Element | string;
  path: string;
  subMenu?: {
    label: string;
    path: string;
  }[];
};

export const menuItems: MenuItems[] = [
  {
    label: "Dashboard",
    path: "/dashboard",
    icon: "pi pi-home",
  },
  {
    label: "My Services",
    path: "/dashboard/services",
    icon: "pi pi-objects-column",
  },
  {
    label: "Transactions history",
    path: "/dashboard/history",
    icon: "pi pi-history",
  },
  {
    label: "Withdrawal history",
    path: "/dashboard/withdrawal-list",
    icon: "pi pi-money-bill",
  },
  {
    label: "Payment Link",
    path: "/dashboard/payment-link",
    icon: "pi pi-link",
  },
  {
    label: "Manage webhook",
    path: "/dashboard/manage-webhook",
    icon: "pi pi-send",
  },
  {
    label: "Settings",
    path: "/dashboard/settings",
    icon: "pi pi-cog",
  },
  {
    label: "Developers",
    path: "/dashboard/developers",
    icon: "pi pi-code",
  },
];
